import { useLocation } from 'react-router-dom';
import { UI_ROUTES } from 'src/constants/routes';

export const useIsZoneSandboxContext = () => {
  const { pathname } = useLocation();
  const isZoneSandboxContext = pathname.includes(UI_ROUTES.ZONE_SANDBOX);

  return isZoneSandboxContext;
};
